<div class="overflow-x-auto rounded-xl">
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="currentActions"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="!!isFilterApplied()"
    [emptyFilterTitle]="
      isArabic() ? 'لا توجد أصناف مطابقة لمعايير البحث' : 'No products found matching your criteria'
    "
    [emptyContentTitle]="isArabic() ? 'لا توجد أصناف متاحة' : 'No products available'"
    [emptyContentDescription]="
      isArabic() ? 'اضغط على «إضافة صنف» لإنشاء أول صنف لك' : 'Click &quot;Add Product&quot; to create your first product.'
    " />
</div>

@if (confirmationModal()) {
  <app-confirmation-dialog
    [error]="errorActivation()"
    (onSubmit)="type() === 'deactivate' ? deactivateProduct() : activateProduct()"
    (onCancel)="confirmationModal.set(false)"
    [productType]="hasSubproducts() ? 'has-sub' : 'has-no-sub'"
    [title]="
      isArabic()
        ? type() === 'deactivate'
          ? 'تأكيد إلغاء تفعيل الصنف'
          : 'تأكيد تفعيل الصنف'
        : type() === 'deactivate'
          ? 'Confirm Product Deactivation'
          : 'Confirm Product Activation'
    "
    [description]="confirmationModalContent().description"
    [confirmContent]="confirmationModalContent().confirmContent"
    [type]="type()"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'" />
}

@if (deleteConfirmationModal()) {
  <app-confirmation-dialog
    [error]="errorDelete()"
    [title]="isArabic() ? 'تأكيد الحذف؟' : 'Confirm Delete?'"
    [description]="
      isArabic() ? 'هل أنت متأكد من رغبتك في حذف هذا الصنف؟' : 'Are you sure you want to delete this product?'
    "
    [confirmContent]="loadingDelete() ? (isArabic() ? 'جارٍ الحذف...' : 'Deleting...') : isArabic() ? 'حذف' : 'Delete'"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    (onSubmit)="confirmDelete()"
    (onCancel)="deleteConfirmationModal.set(false)" />
}

@if (isSuccessNotification()) {
  <app-successful-notification
    type="success"
    [title]="
      isArabic()
        ? type() === 'deactivate'
          ? 'تم إلغاء تفعيل الصنف'
          : 'تم تفعيل الصنف'
        : type() === 'deactivate'
          ? 'Product deactivated successfully. The product is now hidden from customers.'
          : 'Product activated successfully. The product is now visible to customers.'
    " />
}

@if (deleteSuccess()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم حذف الصنف بنجاح.' : 'Product deleted successfully.'" />
}
